import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

const ReactSelectWrapper = ({ label, id, values, selected, onBlur }) => {
    const handleChange = (option) => {
        const syntheticEvent = {
            target: {
                id,
                value: option ? option.value : "",
            },
        };
        onBlur(syntheticEvent);
    };

    const selectedOption = values.find((opt) => opt.value === selected) || null;

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <Typography variant="body2" fontWeight="500">{label}</Typography>
            <Select
                options={values}
                value={selectedOption}
                onChange={handleChange}
                onBlur={() => { }}
                isClearable
            />
        </div>
    );
};

ReactSelectWrapper.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired,
    selected: PropTypes.any,
    onBlur: PropTypes.func.isRequired,
};

export default ReactSelectWrapper;



// WEBPACK FOOTER //
// ./src/components/InheritPermission/reactSelector.js